import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Heart = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00739 4.52474C7.26398 3.68285 6.4632 3.19026 5.66345 3.01275C4.71509 2.80226 3.83478 3.05148 3.17702 3.57548C1.87305 4.61428 1.47139 6.70878 2.91022 8.32556L2.9231 8.34002L7.49239 12.8584C7.76748 13.1304 8.21049 13.1296 8.48462 12.8567L13.0138 8.34615L13.0196 8.34001C14.5085 6.77214 14.1734 4.70708 12.8725 3.66854C12.2219 3.14909 11.3465 2.90205 10.3965 3.09351C9.59509 3.25503 8.77924 3.71932 8.00739 4.52474ZM3.80514 7.50444L7.98635 11.6391L12.1446 7.49795C13.1327 6.45182 12.8629 5.21472 12.1149 4.61756C11.7404 4.3186 11.2292 4.16445 10.6364 4.28392C10.0378 4.40456 9.30301 4.81708 8.54184 5.75368C8.2508 6.11179 7.69729 6.0983 7.42276 5.73046C6.69513 4.75554 5.98163 4.32726 5.40033 4.19824C4.82627 4.07083 4.3178 4.21925 3.93366 4.52528C3.15715 5.14387 2.86167 6.43049 3.80514 7.50444Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Heart;
